import { Component } from '@theme/component';
import { morph } from '@theme/morph';

class PlpVisualFiltersComponent extends Component {
  #controller = new AbortController();
  currentPathname = window.location.pathname;
  /** @type {string | null} */
  sectionId = null;

  connectedCallback() {
    this.sectionId = this.dataset.sectionId || null;
    const { signal } = this.#controller;

    this.handleLocationChange = this.handleLocationChange.bind(this);
    window.addEventListener('locationchange', this.handleLocationChange, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  async handleLocationChange() {
    if (this.currentPathname !== window.location.pathname && this.sectionId) {
      this.currentPathname = window.location.pathname;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.sectionId);

      try {
        this.classList.add('loading');
        const { signal } = this.#controller;
        const response = await fetch(url.toString(), { signal });
        const sectionHtml = await response.text();
        const parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const fresh = parsedSection.querySelector('plp-visual-filters .visual-filters-wrapper');
        const current = this.querySelector('.visual-filters-wrapper');

        if (fresh?.childElementCount && fresh?.childElementCount > 0) {
          this.style.display = '';
        } else {
          this.style.display = 'none';
        }

        if (current && fresh) {
          morph(current, fresh);
        }
      } finally {
        this.classList.remove('loading');
      }
    }
  }

  /** @param {MouseEvent} event */
  handleFilterClick = (event) => {
    // `event.target` is the anchor even when the shopper clicks the image or title:
    // the delegated dispatcher in component.js proxies it to the element carrying
    // the `on:click` binding.
    const target = event.target;
    if (!(target instanceof HTMLAnchorElement)) return;

    const href = target.getAttribute('href');
    if (!href || href === '#') return;

    if (/^(https?:\/\/|mailto:|tel:)/.test(href)) return;
    if (href.startsWith('/') && !href.startsWith(window.location.pathname)) return;
    event.preventDefault();
    const newUrl = new URL(href, window.location.origin);

    if (href.startsWith('?')) {
      newUrl.pathname = window.location.pathname;
    }

    const finalUrl = newUrl.toString();
    const hasHash = finalUrl.includes('#');
    const urlWithHash = hasHash ? finalUrl : `${finalUrl}${window.location.hash}`;

    history.pushState({}, '', urlWithHash);
    window.dispatchEvent(new Event('cio-plp-url-update'));
  };
}

if (!customElements.get('plp-visual-filters')) {
  customElements.define('plp-visual-filters', PlpVisualFiltersComponent);
}
